"use strict"; ///////////////////////////////////////////////////////////////////////////////
//
// Licensed under the Apache License, Version 2.0  ( the  "License" );  you may 
// not use this file except in compliance with the License.  You may  obtain  a 
// copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required  by  applicable  law  or  agreed  to  in  writing,  software 
// distributed under the License is distributed on an "AS  IS"  BASIS,  WITHOUT
// WARRANTIES OR CONDITIONS  OF  ANY  KIND, either express or implied.  See the 
// License for the specific  language  governing  permissions  and  limitations 
// under the License.

var _possibleConstructorReturn = require("/home/user/RiderProjects/KernelManagementLab/Universe.W3Top/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/user/RiderProjects/KernelManagementLab/Universe.W3Top/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/user/RiderProjects/KernelManagementLab/Universe.W3Top/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/home/user/RiderProjects/KernelManagementLab/Universe.W3Top/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/user/RiderProjects/KernelManagementLab/Universe.W3Top/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Generator = require("./generators");

var Constant = require("./utilities");

var Iterator = require("./iterators"); //-----------------------------------------------------------------------------
//  Implementation of EnumerableConstructor interface
//-----------------------------------------------------------------------------

/**
* Converts any Iterable<T> object into LINQ-able object
* @param TSource An Array, Map, Set, String or other Iterable object.
*/


function getEnumerable(TSource) {
  return new EnumerableImpl(TSource);
}

exports.default = getEnumerable;
exports.AsEnumerable = getEnumerable;
exports.asEnumerable = getEnumerable;
exports.From = getEnumerable;
exports.from = getEnumerable;
/**
* Generates <count> of <T> elements starting with <start>. T is any
* type which could be cast to number: number, enum, etc.
* @param start First value in sequence.
* @param count Number of elements to iteratel.
* @example
*     var sum = Range(0, 7).Sum();
*/

function getRange(start, count) {
  return new EnumerableImpl(undefined, Generator.Range, [start, count]);
}

exports.range = getRange;
exports.Range = getRange;
/**
* Repeat element <start> of type T <count> of times.
* @param start First value in sequence.
* @param count Number of elements to iteratel.
* @example
*     var sum = Repeat("v", 7);
*/

function getRepeat(value, count) {
  return new EnumerableImpl(undefined, Generator.Repeat, [value, count]);
}

exports.repeat = getRepeat;
exports.Repeat = getRepeat; //-----------------------------------------------------------------------------
//  Enumerable Implementation
//-----------------------------------------------------------------------------

var EnumerableImpl =
/*#__PURE__*/
function () {
  function EnumerableImpl(target, factory, arg) {
    _classCallCheck(this, EnumerableImpl);

    this._target = target;
    this._factory = factory;
    this._factoryArg = arg; // JavaScript naming convention

    this['aggregate'] = this.Aggregate;
    this['all'] = this.All;
    this['any'] = this.Any;
    this['average'] = this.Average;
    this['chunkBy'] = this.ChunkBy;
    this['contains'] = this.Contains;
    this['count'] = this.Count;
    this['max'] = this.Max;
    this['min'] = this.Min;
    this['elementAt'] = this.ElementAt;
    this['elementAtOrDefault'] = this.ElementAtOrDefault;
    this['first'] = this.First;
    this['firstOrDefault'] = this.FirstOrDefault;
    this['last'] = this.Last;
    this['lastOrDefault'] = this.LastOrDefault;
    this['sequenceEqual'] = this.SequenceEqual;
    this['single'] = this.Single;
    this['singleOrDefault'] = this.SingleOrDefault;
    this['sum'] = this.Sum;
    this['toArray'] = this.ToArray;
    this['toMap'] = this.ToMap;
    this['toDictionary'] = this.ToDictionary;
    this['defaultIfEmpty'] = this.DefaultIfEmpty;
    this['concat'] = this.Concat;
    this['distinct'] = this.Distinct;
    this['except'] = this.Except;
    this['groupBy'] = this.GroupBy;
    this['groupJoin'] = this.GroupJoin;
    this['intersect'] = this.Intersect;
    this['join'] = this.Join;
    this['ofType'] = this.OfType;
    this['orderBy'] = this.OrderBy;
    this['orderByDescend'] = this.OrderByDescending;
    this['range'] = this.Range;
    this['repeat'] = this.Repeat;
    this['reverse'] = this.Reverse;
    this['select'] = this.Select;
    this['selectMany'] = this.SelectMany;
    this['skip'] = this.Skip;
    this['skipWhile'] = this.SkipWhile;
    this['take'] = this.Take;
    this['takeWhile'] = this.TakeWhile;
    this['union'] = this.Union;
    this['where'] = this.Where;
    this['zip'] = this.Zip;
  } ///////////////////////////////////////////////////////////////////////////

  /** Returns JavaScript iterator */


  _createClass(EnumerableImpl, [{
    key: Symbol.iterator,
    value: function value() {
      return null != this._factory ? this._factory.apply(this, this._factoryArg) : this._target[Symbol.iterator]();
    }
    /** Returns C# style enumerator */

  }, {
    key: "GetEnumerator",
    value: function GetEnumerator() {
      return new Iterator.CSharpEnumerator(this[Symbol.iterator]());
    }
  }, {
    key: "Aggregate",
    value: function Aggregate(alpha) {
      var beta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Constant.selfFn;
      var gamma = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Constant.selfFn;
      var zero;
      var method;
      var selector;

      if (Constant.CONST_FUNCTION === typeof alpha) {
        method = alpha;
        selector = beta;
      } else {
        zero = alpha;
        method = beta;
        selector = gamma;
      }

      var result = zero;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var value = _step.value;
          if ([null, undefined].indexOf(result) > -1 || isNaN(result) && !result) result = Constant.getDefaultVal(typeof value);
          result = method(result, value);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return selector(result);
    }
  }, {
    key: "All",
    value: function All() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constant.trueFn;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var value = _step2.value;

          if (!predicate(value)) {
            return false;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return true;
    }
  }, {
    key: "Any",
    value: function Any(predicate) {
      var iterator; // Check if at least one exist

      if (!predicate && (iterator = this[Symbol.iterator]())) {
        return !iterator.next().done;
      } // Check if any satisfy the criteria


      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var value = _step3.value;

          if (predicate(value)) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return false;
    }
  }, {
    key: "Average",
    value: function Average() {
      var func = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constant.selfFn;
      var sum = 0,
          count = 0;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var value = _step4.value;
          sum += func(value);
          count++;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return sum / count;
    }
  }, {
    key: "Contains",
    value: function Contains(value) {
      var equal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a, b) {
        return a === b;
      };
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var item = _step5.value;

          if (equal(item, value)) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return false;
    }
  }, {
    key: "Count",
    value: function Count(predicate) {
      var count = 0;

      if (predicate) {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = this[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var value = _step6.value;

            if (predicate(value)) {
              count++;
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      } else if (this._target && this._target[Constant.CONST_LENGTH]) {
        count = this._target[Constant.CONST_LENGTH];
      } else {
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = this[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var _value = _step7.value;
            count++;
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }
      }

      return count;
    }
  }, {
    key: "Max",
    value: function Max() {
      var transform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constant.selfFn;
      var value,
          max,
          hasValue = false;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var item = _step8.value;
          value = transform(item);

          if (hasValue) {
            if (max < value) max = value;
          } else {
            max = value;
            hasValue = true;
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      if (!hasValue) throw Constant.CONST_NO_ELEMENTS;
      return max;
    }
  }, {
    key: "Min",
    value: function Min() {
      var transform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constant.selfFn;
      var value,
          min,
          hasValue = false;
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = this[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var item = _step9.value;
          value = transform(item);

          if (hasValue) {
            if (min > value) min = value;
          } else {
            min = value;
            hasValue = true;
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      if (!hasValue) throw Constant.CONST_NO_ELEMENTS;
      return min;
    }
  }, {
    key: "ElementAt",
    value: function ElementAt(index) {
      if (Array.isArray(this._target)) {
        if (0 > index || this._target[Constant.CONST_LENGTH] <= index) {
          throw Constant.CONST_OUTOFRANGE;
        }

        return this._target[index];
      }

      var count = 0;
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = this[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var value = _step10.value;

          if (index > count++) {
            continue;
          }

          return value;
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      throw Constant.CONST_OUTOFRANGE;
    }
  }, {
    key: "ElementAtOrDefault",
    value: function ElementAtOrDefault(index) {
      if (Array.isArray(this._target)) {
        var length = this._target[Constant.CONST_LENGTH];

        if (0 > index || length <= index) {
          var _value2 = this._target[0];
          return 0 < length ? Constant.getDefaultVal(typeof _value2, _value2) : undefined;
        }

        return this._target[index];
      }

      var value,
          count = 0;
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = this[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var item = _step11.value;

          if (index === count++) {
            return item;
          }

          value = item;
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }

      return Constant.getDefaultVal(typeof value, value); // Last good value
    }
  }, {
    key: "First",
    value: function First() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constant.trueFn;
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = this[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var value = _step12.value;

          if (predicate(value)) {
            return value;
          }
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }

      throw Constant.CONST_NOTHING_FOUND;
    }
  }, {
    key: "FirstOrDefault",
    value: function FirstOrDefault() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constant.trueFn;
      var value;
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = this[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var item = _step13.value;
          value = item;

          if (predicate(item)) {
            return item;
          }
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      return Constant.getDefaultVal(typeof value); // Last good value
    }
  }, {
    key: "Last",
    value: function Last() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constant.trueFn;
      var value,
          found = false;
      var _iteratorNormalCompletion14 = true;
      var _didIteratorError14 = false;
      var _iteratorError14 = undefined;

      try {
        for (var _iterator14 = this[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
          var item = _step14.value;

          if (predicate(item)) {
            value = item;
            found = true;
          }
        }
      } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
            _iterator14.return();
          }
        } finally {
          if (_didIteratorError14) {
            throw _iteratorError14;
          }
        }
      }

      if (!found) {
        throw Constant.CONST_NOTHING_FOUND;
      }

      return value;
    }
  }, {
    key: "LastOrDefault",
    value: function LastOrDefault() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constant.trueFn;
      var value,
          lastKnown,
          found = false;
      var _iteratorNormalCompletion15 = true;
      var _didIteratorError15 = false;
      var _iteratorError15 = undefined;

      try {
        for (var _iterator15 = this[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
          var item = _step15.value;

          if (predicate(item)) {
            value = item;
            found = true;
          }

          lastKnown = item;
        }
      } catch (err) {
        _didIteratorError15 = true;
        _iteratorError15 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
            _iterator15.return();
          }
        } finally {
          if (_didIteratorError15) {
            throw _iteratorError15;
          }
        }
      }

      return found ? value : Constant.getDefaultVal(typeof lastKnown);
    }
  }, {
    key: "SequenceEqual",
    value: function SequenceEqual(other) {
      var equal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a, b) {
        return a === b;
      };
      var res1, res2;
      var it1 = this[Symbol.iterator]();
      var it2 = other[Symbol.iterator]();

      while (true) {
        res1 = it1.next();
        res2 = it2.next();
        if (res1.done && res2.done) return true;

        if (res1.done != res2.done || !equal(res1.value, res2.value)) {
          return false;
        }
      }

      ;
    }
  }, {
    key: "Single",
    value: function Single() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constant.trueFn;
      var value,
          hasValue = false;
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = this[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var item = _step16.value;

          if (predicate(item)) {
            if (!hasValue) {
              value = item;
              hasValue = true;
            } else {
              throw Constant.CONST_TOO_MANY;
            }
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }

      if (hasValue) return value;
      throw Constant.CONST_NOTHING_FOUND;
    }
  }, {
    key: "SingleOrDefault",
    value: function SingleOrDefault() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constant.trueFn;
      var value,
          lastKnown,
          hasValue = false;
      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = this[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var item = _step17.value;

          if (predicate(item)) {
            if (!hasValue) {
              value = item;
              hasValue = true;
            } else {
              throw Constant.CONST_TOO_MANY;
            }
          }

          lastKnown = item;
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }

      return hasValue ? value : Constant.getDefaultVal(typeof lastKnown);
    }
  }, {
    key: "Sum",
    value: function Sum() {
      var transform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constant.selfFn;
      var sum = 0;
      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = this[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var value = _step18.value;
          sum += transform(value);
        }
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }

      return sum;
    }
  }, {
    key: "ToArray",
    value: function ToArray() {
      var array = [];
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = this[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var value = _step19.value;
          array.push(value);
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }

      return array;
    }
  }, {
    key: "ToMap",
    value: function ToMap(keySelector) {
      var elementSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Constant.selfFn;
      var dictionary = new Map();
      var _iteratorNormalCompletion20 = true;
      var _didIteratorError20 = false;
      var _iteratorError20 = undefined;

      try {
        for (var _iterator20 = this[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
          var value = _step20.value;
          dictionary.set(keySelector(value), elementSelector(value));
        }
      } catch (err) {
        _didIteratorError20 = true;
        _iteratorError20 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
            _iterator20.return();
          }
        } finally {
          if (_didIteratorError20) {
            throw _iteratorError20;
          }
        }
      }

      return dictionary;
    }
  }, {
    key: "ToDictionary",
    value: function ToDictionary(keySelector) {
      var elementSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Constant.selfFn;
      var dictionary = new Map();
      var _iteratorNormalCompletion21 = true;
      var _didIteratorError21 = false;
      var _iteratorError21 = undefined;

      try {
        for (var _iterator21 = this[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
          var value = _step21.value;
          dictionary.set(keySelector(value), elementSelector(value));
        }
      } catch (err) {
        _didIteratorError21 = true;
        _iteratorError21 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
            _iterator21.return();
          }
        } finally {
          if (_didIteratorError21) {
            throw _iteratorError21;
          }
        }
      }

      return dictionary;
    }
  }, {
    key: "Cast",
    value: function Cast() {
      // TODO: Remove any once TypeScript 2.0 out
      return this;
    } //-------------------------------------------------------------------------
    //  Deferred execution methods
    //-------------------------------------------------------------------------

  }, {
    key: "DefaultIfEmpty",
    value: function DefaultIfEmpty() {
      var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      return new EnumerableImpl(undefined, Generator.DefaultIfEmpty, [this, defaultValue]);
    }
  }, {
    key: "Concat",
    value: function Concat(second) {
      return new EnumerableImpl(undefined, Generator.Concat, [this, second]);
    }
  }, {
    key: "ChunkBy",
    value: function ChunkBy(keySelect) {
      var elementSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Constant.selfFn;
      var resultSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (a, b) {
        return b;
      };
      return new EnumerableImpl(undefined, Generator.ChunkBy, [this, keySelect, elementSelector, resultSelector]);
    }
  }, {
    key: "Distinct",
    value: function Distinct(keySelector) {
      if (keySelector) return new EnumerableImpl(undefined, Generator.Distinct, [this, keySelector]);
      return new EnumerableImpl(undefined, Generator.DistinctFast, [this]);
    }
  }, {
    key: "Except",
    value: function Except(other, keySelector) {
      return new EnumerableImpl(undefined, Generator.Intersect, [this, Constant.getKeys(other, keySelector), true, keySelector]);
    }
  }, {
    key: "GroupBy",
    value: function GroupBy(selKey) {
      var selElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Constant.selfFn;
      var selResult = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Constant.defGrouping;
      var map = Constant.getKeyedMap(this, selKey, selElement);
      return new EnumerableImpl(undefined, Generator.GroupBy, [map, selResult]);
    }
  }, {
    key: "GroupJoin",
    value: function GroupJoin(inner, oKeySelect, iKeySelect) {
      var resultSelector = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Constant.defGrouping;
      return new EnumerableImpl(undefined, Generator.GroupJoin, [this, oKeySelect, resultSelector, Constant.getKeyedMapFast(inner, iKeySelect)]);
    }
  }, {
    key: "Intersect",
    value: function Intersect(other, keySelector) {
      return new EnumerableImpl(undefined, Generator.Intersect, [this, Constant.getKeys(other, keySelector), false, keySelector]);
    }
  }, {
    key: "Join",
    value: function Join(inner, oSelector, iSelector, transform) {
      return new EnumerableImpl(undefined, Generator.Join, [this, oSelector, transform, Constant.getKeyedMapFast(inner, iSelector)]);
    }
  }, {
    key: "OfType",
    value: function OfType(obj) {
      var typeName;

      switch (obj) {
        case Number:
          typeName = Constant.CONST_NUMBER;
          break;

        case Boolean:
          typeName = Constant.CONST_BOOLEAN;
          break;

        case String:
          typeName = Constant.CONST_STRING;
          break;

        case Symbol:
          typeName = Constant.CONST_SYMBOL;
          break;

        default:
          typeName = undefined;
      }

      return new EnumerableImpl(undefined, Generator.OfType, [this, obj, typeName]);
    }
  }, {
    key: "OrderBy",
    value: function OrderBy(keySelect, equal) {
      return new OrderedLinq(this, function (array) {
        return Generator.Forward(array);
      }, keySelect, equal);
    }
  }, {
    key: "OrderByDescending",
    value: function OrderByDescending(keySelect, equal) {
      return new OrderedLinq(this, function (array) {
        return Generator.Reverse(array);
      }, keySelect, equal, true);
    }
  }, {
    key: "Range",
    value: function Range(start, count) {
      return new EnumerableImpl(undefined, Generator.Range, [start, count]);
    }
  }, {
    key: "Repeat",
    value: function Repeat(element, count) {
      return new EnumerableImpl(undefined, Generator.Repeat, [element, count]);
    }
  }, {
    key: "Reverse",
    value: function Reverse() {
      var array = Array.isArray(this._target) ? this._target : this.ToArray();
      return new EnumerableImpl(undefined, Generator.Reverse, [array]);
    }
  }, {
    key: "Select",
    value: function Select(transform) {
      return new EnumerableImpl(undefined, Generator.Select, [this, transform]);
    }
  }, {
    key: "SelectMany",
    value: function SelectMany() {
      var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constant.selfFn;
      var result = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x, s) {
        return s;
      };
      return new EnumerableImpl(undefined, Generator.SelectMany, [this, selector, result]);
    }
  }, {
    key: "Skip",
    value: function Skip(skip) {
      return new EnumerableImpl(undefined, Generator.Skip, [this, skip]);
    }
  }, {
    key: "SkipWhile",
    value: function SkipWhile(predicate) {
      return new EnumerableImpl(undefined, Generator.SkipWhile, [this, predicate]);
    }
  }, {
    key: "Take",
    value: function Take(take) {
      return new EnumerableImpl(undefined, Generator.TakeWhile, [this, function (a, n) {
        return take > n;
      }]);
    }
  }, {
    key: "TakeWhile",
    value: function TakeWhile(predicate) {
      return new EnumerableImpl(undefined, Generator.TakeWhile, [this, predicate]);
    }
  }, {
    key: "Union",
    value: function Union(second, keySelector) {
      if (keySelector) return new EnumerableImpl(undefined, Generator.Union, [this, second, keySelector]);
      return new EnumerableImpl(undefined, Generator.UnionFast, [this, second]);
    }
  }, {
    key: "Where",
    value: function Where() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Constant.trueFn;
      return new EnumerableImpl(undefined, Generator.Where, [this, predicate]);
    }
  }, {
    key: "Zip",
    value: function Zip(second, func) {
      return new EnumerableImpl(undefined, Generator.Zip, [this, second, func]);
    }
  }]);

  return EnumerableImpl;
}();

var OrderedLinq =
/*#__PURE__*/
function (_EnumerableImpl) {
  _inherits(OrderedLinq, _EnumerableImpl);

  function OrderedLinq(target, factory, keySelect, equal) {
    var _this;

    var reversed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    _classCallCheck(this, OrderedLinq);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OrderedLinq).call(this, target, factory));
    _this.reversed = reversed;

    if (keySelect) {
      _this.comparer = equal ? function (a, b) {
        return equal(keySelect(a), keySelect(b));
      } : function (a, b) {
        return Constant.defCompare(keySelect(a), keySelect(b));
      };
    } else {
      _this.comparer = equal;
    }

    _this['thenBy'] = _this.ThenBy;
    _this['thenByDescending'] = _this.ThenByDescending;
    return _this;
  }

  _createClass(OrderedLinq, [{
    key: Symbol.iterator,
    value: function value() {
      if (!this._factoryArg) {
        this._factoryArg = this._target.ToArray();

        if (this.comparer) {
          this._factoryArg.sort(this.comparer);
        } else {
          this._factoryArg.sort();
        }
      }

      return this._factory(this._factoryArg);
    }
  }, {
    key: "ThenBy",
    value: function ThenBy(keySelect, equal) {
      var _this2 = this;

      if (!keySelect && !equal) return this;
      var compare = keySelect ? equal ? function (a, b) {
        return equal(keySelect(a), keySelect(b));
      } : function (a, b) {
        return Constant.defCompare(keySelect(a), keySelect(b));
      } : equal;

      if (!this.comparer) {
        this.comparer = compare;
      } else {
        var superEqual = this.comparer;

        this.comparer = function (a, b) {
          var result = superEqual(a, b);
          return 0 != result ? result : _this2.reversed ? -compare(a, b) : compare(a, b);
        };
      }

      return this;
    }
  }, {
    key: "ThenByDescending",
    value: function ThenByDescending(keySelect, equal) {
      var _this3 = this;

      if (!keySelect && !equal) return this;
      var compare = keySelect ? equal ? function (a, b) {
        return equal(keySelect(a), keySelect(b));
      } : function (a, b) {
        return Constant.defCompare(keySelect(a), keySelect(b));
      } : equal;

      if (!this.comparer) {
        this.comparer = compare;
      } else {
        var superEqual = this.comparer;

        this.comparer = function (a, b) {
          var result = superEqual(a, b);
          return 0 != result ? result : _this3.reversed ? compare(a, b) : -compare(a, b);
        };
      }

      return this;
    }
  }]);

  return OrderedLinq;
}(EnumerableImpl);
/** Copyright (c) ENikS.  All rights reserved. */